module.exports = __webpack_public_path__ + "0fc1903e7fc49f829ea2f4c8d3947e60.png";